export { default } from './Component'
export type { default as HotalPlanCardInfo } from './HotelPlanCard.props'
